import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

/**
 * Navigation item component
 *
 * Defines the basic "Hats & hair", "Heads" etc. navigation items that will
 * display the selected item if available
 *
 * @author Matt Haynes <Matthew.haynes@joipolloi.com>
 * @package Minifigs
 */

const NavigationItem = ({ id, title, isActive, categoryInfo, displayProducts, loading }) => {
    const classes = classNames('navigation-item', 'button', id, {
        'navigation-item-active': isActive,
        'navigation-item-loading': loading,
    });

    return (
        <li
            role="button"
            onClick={() => {
                displayProducts(categoryInfo);
            }}
            className={classes}
        >
            <h3>{title}</h3>
        </li>
    );
};

NavigationItem.propTypes = {
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    emptyText: PropTypes.string,
    isActive: PropTypes.bool,
    onSelect: PropTypes.func,
    categoryInfo: PropTypes.shape({
        emptyText: PropTypes.string,
        handle: PropTypes.string,
        id: PropTypes.string,
        title: PropTypes.string,
    }),
    displayProducts: PropTypes.func,
    loading: PropTypes.bool,
};

export default NavigationItem;
